import { HomeCarouselWeb, Icon, Theme } from 'fitbeat.react-native-components';
import WelcomeImage from 'fitbeat.react-native-components/assets/images/welcome-background.web.png';
import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

export const HomeCarouselAuthLayout = (props) => (
  <div className={`auth-container full-per light-background home-carousel ${props.isDarkTheme && 'dark-background' }`}>
    <div className='grid-x full-per'>
     <div className='cell small-12 medium-6 large-7 hide-for-small-only carousel-container'>
        {props.hasAccessToAStudioGym
          ?
          <img src={WelcomeImage} style={{height: '100%', objectFit: 'cover'}}/>
          :
          <div className='carousel-container'>
            <HomeCarouselWeb {...props} />
          </div>
        }
      </div>
      <div className={`padding-3 cell small-12 medium-6 large-4 align-self-top full-per ${props.hideScroll ? '' : 'scroll'}`} id='right-content'>
        {props.header &&
          <View style={{ flexDirection: 'row', paddingLeft: 15 }}>
            {props.backPress &&
              <TouchableOpacity onPress={props.backPress} style={{ justifyContent: 'center' }}>
                <Icon name={'ios-arrow-back'} size={30} color={Theme.PRIMARY} />
              </TouchableOpacity>
            }
            <h3 className={`onboarding-header ${!props.showHeaderSmallDevices && 'hide-for-small-only'}`}>{props.header}</h3>
          </View>
        }
        {props.children}
      </div>
    </div>
  </div>
);
